import React from "react";
import { Row, Col } from "reactstrap";
import GridsUBS from "./Grid/GridUBS";
import CheckMark from "../images/checkmark.png";
const UBSImages = (props) => {
  let machine_card_details = props.machine_card_details;
  let imageUrls = props.imageUrls;

  return (
    <>
      <Row className="mt-4">
        <Col
          xs={12}
          sm={12}
          lg={12}
          md={12}
          xl={3}
          xxl={3}
          className="text-center"
        >
          <h4>
            {" "}
            <strong>Wheel Arches</strong>
          </h4>
        </Col>
        <Col
          xs={12}
          sm={12}
          lg={12}
          md={12}
          xl={6}
          xxl={6}
          className="text-center"
        >
          <h4>
            <strong>Vehicle Underbody</strong>
          </h4>
        </Col>
        <Col
          xs={12}
          sm={12}
          lg={12}
          md={12}
          xl={3}
          xxl={3}
          className="text-center"
        >
          <h4>
            <strong>Wheel Arches</strong>
          </h4>
        </Col>
      </Row>

      <Row className="mt-3 mx-4">
        <Col xs={12} sm={12} lg={12} md={12} xl={3} xxl={3} className="mx-auto">
          {renderPart("Rear_LH", imageUrls.Rear_LH)}
          {renderPart("Rear_RH", imageUrls.Rear_RH)}
        </Col>
        <Col xs={12} sm={12} lg={12} md={12} xl={6} xxl={6} className="mx-auto">
          <div
            className="image-background-ubs"
            style={{
              backgroundImage: `url(${imageUrls.Vehicle_Underbody})`,
            }}
          >
            {machine_card_details?.Parts?.Vehicle_Underbody?.status === true ? (
              <GridsUBS
                highlightedCells={
                  machine_card_details.Parts.Vehicle_Underbody.grids
                }
                underbodyImage={true}
                model={machine_card_details.model}
              />
            ) : (
              <Col
                xs={12}
                sm={12}
                style={{
                  backgroundImage: `url(${imageUrls.Vehicle_Underbody})`,
                }}
                className="image-background-ubs"
              >
                <img
                  src={CheckMark}
                  alt="Checkmark"
                  className="check_tickmark" 
                  style={{ marginTop: "28%", marginLeft: "52%" }}
                />
              </Col>
            )}
          </div>
        </Col>
        <Col xs={12} sm={12} lg={12} md={12} xl={3} xxl={3} className="mx-auto">
          {renderPart("Front_LH", imageUrls.Front_LH)}
          {renderPart("Front_RH", imageUrls.Front_RH)}
        </Col>
      </Row>
    </>
  );

  function renderPart(partKey, imageUrl) {
    const partDetails = machine_card_details?.Parts?.[partKey];
    const isStatusTrue = partDetails?.status === true;

    return (
      <Row>
        <Col
          xs={12}
          className="mt-5 text-center image-background"
          style={{
            backgroundImage: isStatusTrue ? `url(${imageUrl})` : "none", //`url(${imageUrl})`,
            position: "relative",
            backgroundRepeat: "no-repeat",
          }}
        >
          {isStatusTrue ? (
            <>
              <GridsUBS
                highlightedCells={partDetails.grids}
                rear={machine_card_details?.Model}
              />
            </>
          ) : (
            <>
              <Col
                xs={12}
                sm={12}
                md={12}
                style={{
                  backgroundImage: `url(${imageUrl})`,
                  position: "relative",
                  backgroundRepeat: "no-repeat",
                }}
                className="image-background mt-5 image-blur"
              >
                <img
                  src={CheckMark}
                  alt="Checkmark"
                  className="check_tickmark"
                  style={{ marginTop: "18%" }}
                />
              </Col>
              <h5 className="parts-name-text">{partKey.replace("_", " ")}</h5>
            </>
          )}
        </Col>
      </Row>
    );
  }
};

export default UBSImages;
